// #3037 — map a Zod 400's details[] onto form fields.
import { ApiError } from './api';

export interface FieldErrors {
  /** First message per field, keyed by the path after `${prefix}.`. */
  mapped: Record<string, string>;
  /** Entries whose path is not under the prefix, in server order. `path` is '' when it isn't a string. */
  unmapped: Array<{ path: string; message: string }>;
}

/**
 * Splits `err.body.details` (middleware/validate.ts: `{ path, message }[]`,
 * path joined with '.') into messages under `prefix` and the rest. Read
 * defensively, like refusalText: anything that isn't an ApiError with a
 * details array yields nothing, and an entry without a string message is
 * dropped.
 */
export function fieldErrorsFromDetails(err: unknown, prefix: string): FieldErrors {
  const result: FieldErrors = { mapped: {}, unmapped: [] };
  if (!(err instanceof ApiError)) return result;
  const details = err.body.details;
  if (!Array.isArray(details)) return result;

  const head = `${prefix}.`;
  for (const d of details) {
    const { path, message } = (d ?? {}) as { path?: unknown; message?: unknown };
    if (typeof message !== 'string') continue;
    if (typeof path === 'string' && path.startsWith(head) && path.length > head.length) {
      const field = path.slice(head.length);
      if (!Object.prototype.hasOwnProperty.call(result.mapped, field)) result.mapped[field] = message;
    } else {
      result.unmapped.push({ path: typeof path === 'string' ? path : '', message });
    }
  }
  return result;
}
